import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export const localBreadcrumbs = (strictLocalize: StrictLocalizeFunction) => {
  return {
    HOME: strictLocalize({
      defaultMessage: "Home",
      description: {
        text: "Breadcrumb entry: link to home page",
      },
    }),
    POPULAR_GUIDES: strictLocalize({
      defaultMessage: "Popular guides",
      description: {
        text: "Breadcrumb entry: link to popular guides",
      },
    }),
    SEARCH: strictLocalize({
      defaultMessage: "Search",
      description: {
        text: "Breadcrumb entry: link to search page",
      },
    }),
    RETAILER_GUIDES: strictLocalize({
      defaultMessage: "Retailer Guides",
      description: {
        text: "Breadcrumb entry: link to retailer guides",
      },
    }),
    BRAND_GUIDES: strictLocalize({
      defaultMessage: "Brand Guides",
      description: {
        text: "Breadcrumb entry: link to brand guides",
      },
    }),
  };
};
